export enum PortalLogOutExitCode {
    Undefined = 1,
    PortalAuthorizeFilter = 2,
    PortalAuthorizeAttribute = 3,
    PortalAuthorizeAttributeError = 4,
    JwtAuthFailed = 5,
    GetPageDataEmptyUser = 6,
    GetPageDataUserHasWrongType = 7,
    LoginException = 8,
    LoginApiBadRequest = 9,
    LogOutByUser = 10,
    UpdateLastSeenDateCheck = 11,
    UpdateLastSeenDate = 12,
    UpdateLastSeenDateError = 13,
    AuthGuard = 14,
    AuthInterceptor = 15
}
